import { render, staticRenderFns } from "./org-info-editor.vue?vue&type=template&id=89cfc354&scoped=true&"
import script from "./org-info-editor.vue?vue&type=script&lang=js&"
export * from "./org-info-editor.vue?vue&type=script&lang=js&"
import style0 from "./org-info-editor.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./org-info-editor.vue?vue&type=style&index=1&id=89cfc354&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89cfc354",
  null
  
)

export default component.exports